module.exports = __webpack_public_path__ + "img/product-card-hero-lg.4c9490e.webp";